type BrandMarkProps = {
  compact?: boolean;
};

export default function BrandMark({ compact = false }: BrandMarkProps) {
  return (
    <span className={`brand-mark ${compact ? "is-compact" : ""}`} aria-label="AgentNexus（ANX）">
      <img className="brand-logo-image" src="/anx-logo-lockup-v2.png" alt="" />
    </span>
  );
}
